import React from 'react';
import { useTranslation } from 'react-i18next';
import { CreateAccount } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';

export function CreateAccountPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('create-account-component.metatags.title'),
        description: t('create-account-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.createAccount,
        index: false,
    });

    return <CreateAccount />;
}
